import RfiCategoriesActionMenu from './RfiCategoriesActionMenu.component';

export default RfiCategoriesActionMenu;
